import React, { useState } from "react";
import classNames from "classnames";
import "./index.scss";
import ModalPortal from "../../shared/utils/ModalPortal";

interface ProgressProps {
  inProgress: boolean;
  classes?: string;
}

const Progress: React.FC<ProgressProps> = ({ classes, inProgress }) => {
  return (
    <ModalPortal>
      <div className={classNames("progress-root", { on: inProgress }, classes)}>
        {inProgress && (
          <div className="loadingio-spinner-spin-3p9ce1185f9">
            <div className="ldio-j3o061p6lyr">
              <div>
                <div></div>
              </div>
              <div>
                <div></div>
              </div>
              <div>
                <div></div>
              </div>
              <div>
                <div></div>
              </div>
              <div>
                <div></div>
              </div>
              <div>
                <div></div>
              </div>
              <div>
                <div></div>
              </div>
              <div>
                <div></div>
              </div>
            </div>
          </div>
        )}
      </div>
    </ModalPortal>
  );
};

export default Progress;
